<template>
  <div v-if="updateAvailable" class="pwa-update-container">
    <v-snackbar
      v-model="showUpdateSnackbar"
      :timeout="0"
      color="info"
      location="top"
    >
      <div class="d-flex align-center">
        <v-icon class="mr-2">mdi-update</v-icon>
        <span>A new version is available</span>
      </div>
      <template v-slot:actions>
        <v-btn
          color="white"
          variant="text"
          @click="updateApp"
          :loading="updating"
        >
          Update
        </v-btn>
        <v-btn
          color="white"
          variant="text"
          @click="dismissUpdate"
        >
          Later
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script setup lang="ts">
const { $pwa } = useNuxtApp()
const pwa = $pwa as any

const updateAvailable = ref(false)
const showUpdateSnackbar = ref(false)
const updating = ref(false)

// Check for PWA updates
onMounted(() => {
  if (pwa && typeof pwa.on === 'function') {
    // Listen for update found
    pwa.on('update-found', () => {
      console.log('PWA update found')
      updateAvailable.value = true
      showUpdateSnackbar.value = true
    })

    // Listen for update ready
    pwa.on('update-ready', () => {
      console.log('PWA update ready')
      updateAvailable.value = true
      showUpdateSnackbar.value = true
    })
  }
})

// Update the app
const updateApp = async () => {
  if (pwa && typeof pwa.update === 'function') {
    updating.value = true
    try {
      await pwa.update()
      console.log('PWA updated successfully')
      updateAvailable.value = false
      showUpdateSnackbar.value = false
    } catch (error) {
      console.error('Error updating PWA:', error)
    } finally {
      updating.value = false
    }
  }
}

// Dismiss update notification
const dismissUpdate = () => {
  showUpdateSnackbar.value = false
}
</script>

<style scoped>
.pwa-update-container {
  z-index: 1001;
}
</style> 